import { render } from "./UpcomingCatalog.vue?vue&type=template&id=513f1c4e&ts=true&lang=pug"
import script from "./UpcomingCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingCatalog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__